import { EChartOption } from "echarts";

export const utilizationChartConfig = (
  xAxisData: string[],
  yAxisData: number[],
  goal: number,
  label
): EChartOption => ({
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: xAxisData
  },
  yAxis: {
    type: "value",
    max: 100,
    min: 0
  },
  legend: {
    data: [label],
    bottom: 0
  },
  toolbox: {
    show: true,
    feature: {
      dataView: { show: true, readOnly: false },
      magicType: { show: true, type: ["line", "bar"] },
      restore: { show: true },
      saveAsImage: { show: true }
    }
  },
  series: [
    {
      name: label,
      data: yAxisData,
      type: "line",
      markLine: {
        data: [{ name: "Goal", yAxis: goal }],
        lineStyle: {
          color: "red"
        }
      }
    }
  ],
  grid: [
    {
      show: true
    }
  ]
});
